import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Money from "components/money";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import CartProgress from "./progress";
import CartBoxSelector from "./box-selector";
import { useGlobalContext } from "context/global";
import { selectAndSaveBox } from "actions/cart";
import { closeCart } from "slices/cart";
import clsx from "clsx/lite";

const CartHeader = ({ isSticky, className }) => {
	const { translation } = useGlobalContext();
	const { totalProgress, activeBox, minBox } = useSelector(state => state.cart);

	const dispatch = useDispatch();

	return (
		<div className={clsx("px-6 pt-6", className)}>
			<div className="flex justify-between items-center md:items-end">
				<span className="tracking-wider text-base uppercase max-w-[60%]">
					{translation?.cart?.title} ({totalProgress}{activeBox && `/${activeBox?.size?.value}`})</span>
				{activeBox && <div className="flex justify-end items-center md:items-end flex-wrap">
					<span className="whitespace-nowrap text-body md:text-sm">
						<span className="tracking-wider text-base md:text-sm md:text-secondary lowercase !font-normal">
							{translation.shopping_flow.from}
						</span>
						{" "}
						<span className="font-black ">
							<Money  value={activeBox?.price} />{" "}/
						</span>
					</span>
					<span className="text-secondary text-sm"> {translation.cart?.meal}</span>
					{!isSticky && <button onClick={() => dispatch(closeCart())} className="ml-2 self-center hidden md:inline-block">
						<Close className="size-4" />
					</button>}
				</div>}
			</div>
			<CartProgress totalProgress={totalProgress} />
			{!isSticky && <CartBoxSelector
				activeBox={activeBox}
				minBoxSize={minBox.size.value}
				onBoxClick={(box) => dispatch(selectAndSaveBox(box))}
			/>}
		</div>
	);
};

export default CartHeader;